(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6657],{

/***/ 95244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useGuardAuthedOnly; },
/* harmony export */   "U": function() { return /* binding */ useGuardGuestOnly; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92441);
/* harmony import */ var _authed_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70281);





const useGuardAuthedOnly = ()=>{
    const authed = (0,_authed_model__WEBPACK_IMPORTED_MODULE_2__/* .useAuthed */ .p)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!authed) {
            const currentHref = location.href.substring(location.origin.length);
            next_router__WEBPACK_IMPORTED_MODULE_0___default().replace(pages_router__WEBPACK_IMPORTED_MODULE_3__/* ["default"].login.href */ .Z.login.href + "?next=" + encodeURIComponent(currentHref));
        }
    }, [
        authed
    ]);
};
const useGuardGuestOnly = ()=>{
    const authed = (0,_authed_model__WEBPACK_IMPORTED_MODULE_2__/* .useAuthed */ .p)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (authed) {
            const next = (0,shared_lib__WEBPACK_IMPORTED_MODULE_4__/* .getQueryParam */ .P)("next") || pages_router__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dashboard.href */ .Z.dashboard.href;
            next_router__WEBPACK_IMPORTED_MODULE_0___default().replace(next);
        }
    }, [
        authed
    ]);
};


/***/ }),

/***/ 8254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18874);

const pages = {
    index: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/"),
    login: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/login"),
    signup: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/signup"),
    logout: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/logout"),
    dashboard: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/dashboard"),
    introduce: {
        yourself: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/introduce/yourself"),
        company: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/introduce/company")
    },
    profile: {
        ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/profile"),
        settings: "/profile/settings"
    },
    company: (company)=>({
            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company)),
            finances: {
                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances")),
                education: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/education")),
                    tableOfContent: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/education/table-of-content")),
                    step: (step)=>(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/education/").concat((step.toString().length === 1 ? "0" : "") + step.toString()))
                },
                yearMonth: (year, month)=>({
                        ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month)),
                        plan: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/plan")),
                        fact: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/fact")),
                        results: {
                            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results")),
                            id: (id)=>({
                                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id)),
                                    fundingRequests: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/funding-requests")),
                                    loans: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/loans")),
                                    funds: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/funds")),
                                    directive: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/").concat(year, "-").concat(month, "/results/").concat(id, "/directive"))
                                })
                        }
                    }),
                plan: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/plan")),
                funds: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds")),
                    fundId: (fundId)=>({
                            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId)),
                            expenseItems: {
                                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/expense-items")),
                                edit: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/expense-items/edit"))
                            },
                            history: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/history")),
                            fundingRequests: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/funding-requests")),
                            settings: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funds/").concat(fundId, "/settings"))
                        })
                },
                fundingRequests: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests")),
                    new: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests/new")),
                    id: (id)=>({
                            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests/").concat(id)),
                            edit: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/funding-requests/").concat(id, "/edit"))
                        })
                },
                payouts: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/payouts")),
                    history: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/payouts/history"))
                },
                deferredIncomes: {
                    ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/deferred-incomes")),
                    id: (id)=>(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/deferred-incomes/").concat(id))
                },
                loans: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/loans")),
                settings: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/settings")),
                reports: {
                    balance: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/balance")),
                    cashFlow: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/cash-flow")),
                    expenses: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/expenses")),
                    loans: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/loans")),
                    activeFundingRequests: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/finances/reports/active-funding-requests"))
                }
            },
            departments: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/departments")),
            settings: {
                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings")),
                users: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings/users")),
                roles: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings/roles")),
                general: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/".concat(company, "/settings/general"))
            }
        }),
    admin: {
        ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin"),
        company: (companySlug)=>({
                ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug)),
                profile: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug, "/profile")),
                courses: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug, "/courses")),
                mentors: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/".concat(companySlug, "/mentors"))
            }),
        invites: {
            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/invites"),
            id: (id)=>(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/invites/".concat(id))
        },
        settings: {
            ...(0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings"),
            members: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings/members"),
            courses: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings/courses"),
            mailings: (0,shared_lib__WEBPACK_IMPORTED_MODULE_0__/* .page */ .M)("/admin/settings/mailings")
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (pages);


/***/ }),

/***/ 29359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ canUseDOM; }
/* harmony export */ });
function canUseDOM() {
    return !!( true && window.document && window.document.createElement);
}


/***/ }),

/***/ 92441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
const getQueryParam = (name)=>{
    if (false) {}
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
};


/***/ }),

/***/ 18874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; },
/* harmony export */   "l": function() { return /* binding */ useRouterChange; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const page = (href)=>({
        href
    });
const useRouterChange = function(callback) {
    let deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        next_router__WEBPACK_IMPORTED_MODULE_0___default().events.on("routeChangeStart", callback);
        return ()=>next_router__WEBPACK_IMPORTED_MODULE_0___default().events.off("routeChangeStart", callback);
    }, deps);
};


/***/ }),

/***/ 17205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useForceUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Forces a re-render, similar to `forceUpdate` in class components.
 */ function useForceUpdate() {
    let [, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Object.create(null));
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        dispatch(Object.create(null));
    }, []);
}


/***/ }),

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _can_use_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29359);


/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ const useIsomorphicLayoutEffect = (0,_can_use_dom__WEBPACK_IMPORTED_MODULE_1__/* .canUseDOM */ .N)() ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


/***/ }),

/***/ 76780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var shared_ui_tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72478);
/* harmony import */ var _loading_dots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42966);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74647);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);






const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, ref)=>{
    let { type , htmlType , size , variant , className , loading: propsLoading , children , onClick: propsOnClick , svgOnly , prefix , suffix , icon , disabled , ...restProps } = param;
    const [localLoading, setLocalLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const onClick = async (e)=>{
        if (localLoading || propsLoading || disabled) return;
        // e.preventDefault();
        try {
            setLocalLoading(true);
            await (propsOnClick === null || propsOnClick === void 0 ? void 0 : propsOnClick(e));
        } finally{
            setLocalLoading(false);
        }
    };
    const loading = propsLoading !== null && propsLoading !== void 0 ? propsLoading : localLoading;
    const btn = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().base), variant !== "unstyled" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button), size === "small" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().small), size === "medium" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().medium), size === "large" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().large), type === "secondary" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().secondary), type === "success" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success), type === "error" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error), variant === "ghost" && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ghost), svgOnly && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().svg_only), loading && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loading), disabled && (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled), className),
        type: htmlType,
        ref: ref,
        onClick: onClick,
        ...restProps,
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loader),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loading_dots__WEBPACK_IMPORTED_MODULE_4__/* .LoadingDots */ .x, {
                    size: {
                        small: 4,
                        medium: 5,
                        large: 6
                    }[size || "medium"]
                })
            }),
            !loading && prefix,
            icon,
            children,
            suffix
        ]
    });
    if (restProps.disabledTooltip && disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
            label: restProps.disabledTooltip,
            children: btn
        });
    }
    return btn;
});
Button.defaultProps = {};


/***/ }),

/***/ 42966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LoadingDots; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _loading_dots_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22277);
/* harmony import */ var _loading_dots_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_loading_dots_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const LoadingDots = (props)=>{
    const style = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            ...props.style,
            "--loading-dots-size": props.size && "".concat(props.size, "px")
        }), [
        props.style,
        props.size
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_loading_dots_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loading_dots), props.className),
        style: style,
        id: props.htmlId,
        children: [
            props.children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_loading_dots_module_scss__WEBPACK_IMPORTED_MODULE_3___default().spacer),
                children: props.children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    });
};
LoadingDots.defaultProps = {};


/***/ }),

/***/ 45222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17205);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3403);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/**
 * Welcome to @reach/portal!
 *
 * Creates and appends a DOM node to the end of `document.body` and renders a
 * React tree into it. Useful for rendering a natural React element hierarchy
 * with a different DOM hierarchy to prevent parent styles from clipping or
 * hiding content (for popovers, dropdowns, and modals).
 *
 * @see Docs   https://reach.tech/portal
 * @see Source https://github.com/reach/reach-ui/tree/main/packages/portal
 * @see React  https://reactjs.org/docs/portals.html
 */ 



const __DEV__ = "production" === "development";
/**
 * Portal
 *
 * @see Docs https://reach.tech/portal#portal
 */ const PortalImpl = (param)=>{
    let { children , type ="reach-portal" , containerRef  } = param;
    let mountNode = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    let portalNode = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    let forceUpdate = (0,shared_lib__WEBPACK_IMPORTED_MODULE_3__/* .useForceUpdate */ .N)();
    if (__DEV__) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
            if (containerRef != null) {
                if (typeof containerRef !== "object" || !("current" in containerRef)) {
                    console.warn("@reach/portal: Invalid value passed to the `containerRef` of a " + "`Portal`. The portal will be appended to the document body, but if " + "you want to attach it to another DOM node you must pass a valid " + "React ref object to `containerRef`.");
                } else if (containerRef.current == null) {
                    console.warn("@reach/portal: A ref was passed to the `containerRef` prop of a " + "`Portal`, but no DOM node was attached to it. Be sure to pass the " + "ref to a DOM component.\n\nIf you are forwarding the ref from " + "another component, be sure to use the React.forwardRef API. " + "See https://reactjs.org/docs/forwarding-refs.html.");
                }
            }
        }, [
            containerRef
        ]);
    }
    (0,shared_lib__WEBPACK_IMPORTED_MODULE_4__/* .useIsomorphicLayoutEffect */ .L)(()=>{
        // This ref may be null when a hot-loader replaces components on the page
        if (!mountNode.current) return;
        // It's possible that the content of the portal has, itself, been portaled.
        // In that case, it's important to append to the correct document element.
        let ownerDocument = mountNode.current.ownerDocument;
        let body = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || ownerDocument.body;
        portalNode.current = ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.createElement(type);
        body.appendChild(portalNode.current);
        forceUpdate();
        return ()=>{
            if (portalNode.current && body) {
                body.removeChild(portalNode.current);
            }
        };
    }, [
        type,
        forceUpdate,
        containerRef
    ]);
    return portalNode.current ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(children, portalNode.current) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        ref: mountNode
    });
};
const Portal = (param)=>{
    let { unstable_skipInitialRender , ...props } = param;
    let [hydrated, setHydrated] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        if (unstable_skipInitialRender) {
            setHydrated(true);
        }
    }, [
        unstable_skipInitialRender
    ]);
    if (unstable_skipInitialRender && !hydrated) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PortalImpl, {
        ...props
    });
};
Portal.displayName = "Portal";



/***/ }),

/***/ 72478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95237);
/* harmony import */ var shared_ui_menu_lib_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45222);
/* harmony import */ var _tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33165);
/* harmony import */ var _tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const Tooltip = (props)=>{
    const [referenceElement, setReferenceElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const modifiers = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (props.arrow) {
            return [
                {
                    name: "arrow",
                    options: {
                        element: arrowElement
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            11
                        ]
                    }
                }
            ];
        }
        return [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        4
                    ]
                }
            }
        ];
    }, [
        arrowElement,
        props.arrow
    ]);
    const { styles: popperStyles , attributes  } = (0,react_popper__WEBPACK_IMPORTED_MODULE_2__/* .usePopper */ .D)(referenceElement, popperElement, {
        modifiers,
        placement: props.placement
    });
    const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const onMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>setVisible(true), [
        setVisible
    ]);
    const onMouseLeave = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>setVisible(false), [
        setVisible
    ]);
    var _props_visible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            react__WEBPACK_IMPORTED_MODULE_1__.Children.map(props.children, (child)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child, {
                    ...child.props,
                    ref: setReferenceElement,
                    onMouseEnter,
                    onMouseLeave
                })),
            ((_props_visible = props.visible) !== null && _props_visible !== void 0 ? _props_visible : visible) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_menu_lib_portal__WEBPACK_IMPORTED_MODULE_3__/* .Portal */ .h, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: setPopperElement,
                    style: popperStyles.popper,
                    ...attributes.popper,
                    className: (_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: setArrowElement,
                            style: popperStyles.arrow,
                            className: (_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tooltip),
                            children: props.label
                        })
                    ]
                })
            })
        ]
    });
};
Tooltip.defaultProps = {
    arrow: true,
    placement: "top"
};


/***/ }),

/***/ 74647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"button_base__qmOCf","button":"button_button__FUDeW","disabled":"button_disabled__bUwaN","svg_only":"button_svg_only___laDq","loader":"button_loader__aZpUc","secondary":"button_secondary__bEjIM","error":"button_error__viQ6l","small":"button_small__MSDKk","medium":"button_medium__sjcd0","large":"button_large___eDlY","loading":"button_loading__7_lWt","ghost":"button_ghost__pBDum"};

/***/ }),

/***/ 22277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading_dots":"loading-dots_loading_dots__J7CPx","spacer":"loading-dots_spacer__IXM4o","blink":"loading-dots_blink__IuO51"};

/***/ }),

/***/ 33165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__GjMrC","no_border":"tooltip_no_border__wVqQ2","wrapper":"tooltip_wrapper__fVhnP","show":"tooltip_show__cDre8","arrow":"tooltip_arrow__iQOz9"};

/***/ })

}]);